import mockRouterAction from '@/components/actionSheet/mockRouterAction'

import { isEmptyObject, isNullOrEmpty, getPosition } from '@/utils'
import { E_SKUTAG } from '@/config'
import { getStoreInfo, getStoreList } from '@/business/customised-goods'
import storeList from '../storeList'

import { queryStoreListBySpuId } from '../services'
import { STORAGE_NAME_POSITION } from '../constants'
import { goMapRouter } from '../lib/map'

/**
 * 在商详页，订单确认页打开更换门店功能，isOpenReplacement 可以作为开启更换门店功能 和 标识是否为定制sku门店功能使用
 * 订单详情页，不打开更换门店功能，所以需要新增一个字段来识别 isCustomisedGoods
 */
export default {
  inject: {
    busiMapTrackParams: {
      default: null
    },
    allStoreTrackParams: {
      default: null
    }
  },
  // props: ['spuId', 'skuTags', 'businessKey', 'titleFrom', 'isOpenReplacement'],
  props: {
    spuId: {
      type: [String, Number]
    },
    skuTags: {
      type: [Array, null]
    },
    businessKey: {
      type: [String, Number]
    },
    titleFrom: {
      type: String
    },
    isOpenReplacement: {
      type: Boolean
    },
    isCustomisedGoods: {
      type: Boolean
    },
    isSelfPhoto: {
      type: Boolean,
      default: false
    },
    isInOrderDetail: {
      type: Boolean
    },
    parentSpuId: {
      type: [String, Number]
    },

    product: {
      type: Object
    }
  },
  components: {
    mockRouterAction,
    storeList
  },
  data() {
    return {
      routerName: 'storeList',
      newSpuId:
        this.parentSpuId || this.spuId || this.$route.params.spuId || '', // 详情页门店更换后，跳转至订单提交页要把原spuId带过来，方便继续更换门店
      storeList: [],
      storeInfo: {},
      position: {}
    }
  },
  async created() {
    await this.getPosition()
    const isCustomsizedGoods = this.isCustomisedGoods
    const businessId = this.businessKey
      ? this.businessKey
      : this.getBusinessID()
    console.log('parentSpuId=', this.parentSpuId)
    console.log('spuId=', this.spuId)
    console.log('newSpuId=', this.newSpuId)
    if (this.isInOrderDetail) {
      // 订单详情-具体子商品；商详，订单确认页调用其他接口
      // 服务门店
      this.storeList = await queryStoreListBySpuId(this.newSpuId, this.position)
    } else if (isCustomsizedGoods) {
      // 适用门店
      this.storeList = await getStoreList(this.newSpuId, this.position)
    } else {
      // 服务门店
      this.storeList = await queryStoreListBySpuId(this.newSpuId, this.position)
    }

    // 从门店详情页进来，外露为当前门店
    const compare = this.storeList.length > 0
    if (compare) {
      const storeInfo = getStoreInfo(this.storeList, businessId)
      this.storeInfo = storeInfo
      // 订单确认页提交订单时带上pop门店信息，便于在订单详情页展示
      //  定制SKU 商详页面、订单确认页 要获取子商品
      const { city: cityCode, addressCity: cityName } = storeInfo
      this.$emit('onStoreSelected', storeInfo)
    }
    this.$emit('StoreController', compare)
  },
  computed: {
    /**
     * 未授权不展示具体公里数
     */
    isAuthorizedPosition() {
      return this.checkPosition()
    },
    storeLength() {
      return this.storeList.length
    },
    distance() {
      const { distance, distanceKm } = this.storeInfo
      if (+distance > 6e4) {
        return '>60km'
      }
      return distanceKm
    },
    address() {
      const {
        // addressProvince,
        // addressCity,
        // addressDistrict,
        addressStreet
      } = this.storeInfo
      // return addressProvince + addressCity + addressDistrict + addressStreet
      return addressStreet
    },
    storeLabel() {
      // skuTag in [1,2,3,5] 显示为适用商家
      // const skuTags = this.skuTags || []
      // let arr = [
      //   E_SKUTAG.SELFSTORE,
      //   E_SKUTAG.SELFHOME,
      //   E_SKUTAG.POPYUSAO,
      //   E_SKUTAG.POPENTITY,
      // ]
      // if (skuTags.find((x) => arr.indexOf(x) !== -1)) {
      //   return '商家'
      // }
      // 定制sku 展示位 服务门店
      const str = '门店'
      if (this.isSelfPhoto) {
        return `拍摄${str}`
      }
      if (this.isOpenReplacement || this.isCustomisedGoods) {
        return `服务${str}`
      }
      if (this.isSelfPhoto) {
        return `拍摄${str}`
      }
      return `适用${str}`
    }
  },
  methods: {
    checkPosition(position = this.position) {
      return !isNullOrEmpty(position) && !isEmptyObject(position)
    },
    async getPosition() {
      // 定位方法已提供缓存功能
      // 订单确认页从缓存取定位信息
      let { name: routerName } = this.$route
      if (routerName === 'product-confirm') {
        let position = JSON.parse(sessionStorage.getItem(STORAGE_NAME_POSITION))
        // 有可能取不到 或取值为null
        if (!this.checkPosition(position)) {
          position = await getPosition()
        }
        this.position = position
      } else {
        this.position = await getPosition(false)
        if (this.checkPosition()) {
          sessionStorage.setItem(
            STORAGE_NAME_POSITION,
            JSON.stringify(this.position)
          )
        }
      }
    },
    /**
     * 1. 尝试从querystring内取
     * 2. 因为组件公用，商详页，订单提交页，订单详情页都会使用，不可能每处都加query,所以先把businessId在商品详情页缓存
     */
    getBusinessID() {
      const storageName = `suitabel_store_businessId_${this.newSpuId}`
      let { businessKey, businessId } = this.$route.query // 参数有可能不统一，兼容
      if (businessKey) {
        businessId = businessKey
      }
      if (!businessId) {
        businessId = JSON.parse(sessionStorage.getItem(storageName))
      } else {
        sessionStorage.setItem(storageName, businessId)
      }
      return businessId
    },
    showStoreList() {
      this.allStoreTrackParams && this.$$newTrackClick(this.allStoreTrackParams)
      this.$router.push({
        query: {
          ...this.$route.query,
          routerAction: true,
          routerName: this.routerName
        }
      })
      this.$refs.mra.show()
    },
    goMap() {
      this.busiMapTrackParams && this.$$newTrackClick(this.busiMapTrackParams)
      goMapRouter(this, this.storeInfo)
      // const {
      //   storeName: desc,
      //   longitude: lng,
      //   latitude: lat,
      //   distanceKm: distance,
      //   addressStreet: address,
      // } = this.storeInfo
      // // console.log(desc, lng, lat)
      // this.$router.push({
      //   name: 'map',
      //   query: {
      //     lng,
      //     lat,
      //     desc,
      //     distance,
      //     address,
      //   },
      // })
    },
    handleStoreChange(storeInfo) {
      this.storeInfo = storeInfo
      // 定制SKU更换门店
      this.$emit('onStoreSelected', storeInfo)
      // 订单提交页更换门店后要重新刷新页面，因为在当前页面代码 line 121 处，已经触发一次onStoreSelected事件了，如果不加区分，仍然使用该事件，会陷入死循环，一直刷新中
      this.$emit('onStoreChanged', storeInfo)
      // history.go(-1)
      this.$router.go(-1)
    },
  }
}
